module.exports = "/static/Images/Roboto/Roboto-ThinItalic.ttf";